import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { GetAllPlanGroupsApi } from "../../../api/GetAllPlanGroups";
import GetCascadeFromPlansApi from "../../../api/GetCascadeFromPlansApi";
import { useSelector } from "react-redux";

const { Option } = Select;

function TopPlanFilterModal(props) {
  const [submit, setSubmit] = useState(false);
  const [planGroups, setPlanGroups] = useState([]);
  const [cascadeFromPlans, setCascadeFromPlans] = useState([]);
  const [form] = Form.useForm();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const positionState = useSelector((state) => state.positionState.value);

  function handleCancel() {
    setSubmit(false);
    setPlanGroups([]);
    setCascadeFromPlans([]);
    props.handleCancel();
    form.resetFields();
  }

  useEffect(() => {
    if (props.visible) {
      getPlanGroups();
      getCascadeFromPlans();
      props.filterBy?.title &&
        form.setFields([{ name: "title", value: props.filterBy?.title }]);
    }
  }, [props.visible]);

  async function getPlanGroups() {
    const apiResponse = await GetAllPlanGroupsApi();
    if (apiResponse.message === "success") {
      setPlanGroups(apiResponse.planGroups);
      props.filterBy?.planGroup &&
        form.setFields([
          {
            name: "planGroup",
            value: props.filterBy?.planGroup,
          },
        ]);
    }
  }

  async function getCascadeFromPlans() {
    const apiResponse = await GetCascadeFromPlansApi(
      perfCycleState.id,
      positionState.id
    );
    if (apiResponse.success) {
      setCascadeFromPlans(apiResponse.data);
      props.filterBy?.cascadeFrom &&
        form.setFields([
          {
            name: "planGroup",
            value: props.filterBy?.cascadeFrom,
          },
        ]);
    }
  }

  function onFinish(values) {
    setSubmit(true);
    props.handleOk(values);
    handleCancel();
  }

  return (
    <Modal
      title="Filter Organization"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="organizationFilter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Title" name="title">
          <Input placeholder="Plan title" />
        </Form.Item>

        <Form.Item label="Plan group" name="planGroup">
          <Select showSearch placeholder="Select plan group">
            {planGroups.map((group) => {
              return (
                <Option key={group.id} value={group.id}>
                  {group.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item label="Cascade from" name="cascadeFrom">
          <Select showSearch placeholder="Select cascade from plan">
            {cascadeFromPlans.map((plan) => {
              return (
                <Option key={plan.cascadeFromId} value={plan.cascadeFromId}>
                  {plan.cascadeFromTitle}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default TopPlanFilterModal;
